import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Form, Grid, Button, Input, Checkbox, Icon } from 'semantic-ui-react';
import { Commons } from 'components';

import * as cm_action from 'actions/commons';
import * as sik_action from 'actions/sikdae';
import { KimAndChangCompanySupportRate, WelcomeSystemINCCompanySupportRate } from 'constants/enum';

const propTypes = {
  isKimAndChang: PropTypes.bool, // 김앤장 급여공제 화면 여부
  isWelcomeSystemINC: PropTypes.bool // 웹컴 시스템 이앤씨 화면 여부
};

const defaultProps = {
  isKimAndChang: false, // 기본값은 김앤장 급여공제가 아님
  isWelcomeSystemINC: false
};

class DeductionSearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sikdaeGroupVal: 0,
      // 김앤장 급여공제 화면에서만 회사 지원 비율 설정
      companySupportRate: props.isKimAndChang
        ? props.companySupportRate || KimAndChangCompanySupportRate.SEVENTY_SIX_POINT_SEVEN_PERCENT
        : null
    };
  }

  componentDidMount() {
    // 김앤장 급여공제 화면에서만 회사 지원 비율 초기값 설정
    if ((this.props.isKimAndChang || this.props.isWelcomeSystemINC) && this.props.companySupportRate) {
      this.setState({ companySupportRate: this.props.companySupportRate });
    }
  }

  componentDidUpdate(prevProps) {
    // 김앤장 급여공제 화면에서만 회사 지원 비율 props 변경 감지
    if (
      (this.props.isKimAndChang || this.props.isWelcomeSystemINC) &&
      prevProps.companySupportRate !== this.props.companySupportRate
    ) {
      this.setState({ companySupportRate: this.props.companySupportRate });
    }
  }

  staffSearchClick = () => {
    const { modalAction } = this.props;
    modalAction('open', true);
  };

  deleteSelectedStaff = () => {
    const { fn } = this.props;
    fn.choiceStaff('', '');
  };

  // 사무소 지원금 변경 핸들러 (김앤장 급여공제 전용)
  handleCompanySupportRateChange = (e, { value }) => {
    if (!this.props.isKimAndChang && !this.props.isWelcomeSystemINC) return;

    this.setState({ companySupportRate: value });
    // 부모 컴포넌트에 변경 알림
    if (this.props.onCompanySupportRateChange) {
      this.props.onCompanySupportRateChange(value);
    }
  };

  style = (e, type) => {
    if (type === 'over') {
      e.target.style.cursor = 'pointer';
      e.target.style.background = '#e5e5e5';
      e.target.style.color = 'white';
    } else {
      e.target.style.background = 'white';
      e.target.style.color = 'black';
    }
  };

  render() {
    const { staff, submitForm, defaultDay } = this.props;
    const { companySupportRate } = this.state;

    return (
      <Form className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group>
                <Commons.DateForm defaultDay={defaultDay} maxDays={this.props.maxDays} />
              </Form.Group>
            </Grid.Column>
            <Grid.Column width={2} className="right">
              <Button color="black" inverted content="조회" onClick={submitForm} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group inline style={{ margin: 0 }}>
                {/* 사무소 지원금 선택 - 김앤장 급여공제에서만 표시 */}
                {this.props.isKimAndChang && (
                  <Form.Field>
                    <Button.Group basic className="company-support-btn">
                      <Button
                        value={KimAndChangCompanySupportRate.SEVENTY_SIX_POINT_SEVEN_PERCENT}
                        className={
                          companySupportRate === KimAndChangCompanySupportRate.SEVENTY_SIX_POINT_SEVEN_PERCENT
                            ? 'active'
                            : ''
                        }
                        onClick={this.handleCompanySupportRateChange}
                      >
                        76.7% 지원
                      </Button>
                      <Button
                        value={KimAndChangCompanySupportRate.SIXTY_FIVE_PERCENT}
                        className={
                          companySupportRate === KimAndChangCompanySupportRate.SIXTY_FIVE_PERCENT ? 'active' : ''
                        }
                        onClick={this.handleCompanySupportRateChange}
                      >
                        65% 지원
                      </Button>
                    </Button.Group>
                  </Form.Field>
                )}
                {/* 사무소 지원금 선택 - 웰컴시스템아이엔씨(삼성물산) 급여공제에서만 표시 */}
                {this.props.isWelcomeSystemINC ? (
                  <Form.Field>
                    <Button.Group basic className="company-support-btn">
                      <Button
                        value={WelcomeSystemINCCompanySupportRate.FORTY_FIVE_PERCENT}
                        className={
                          companySupportRate === WelcomeSystemINCCompanySupportRate.FORTY_FIVE_PERCENT ? 'active' : ''
                        }
                        onClick={this.handleCompanySupportRateChange}
                      >
                        45% 지원
                      </Button>
                      <Button
                        value={WelcomeSystemINCCompanySupportRate.FORTY_PERCENT}
                        className={
                          companySupportRate === WelcomeSystemINCCompanySupportRate.FORTY_PERCENT ? 'active' : ''
                        }
                        onClick={this.handleCompanySupportRateChange}
                      >
                        40% 지원
                      </Button>
                    </Button.Group>
                  </Form.Field>
                ) : null}

                <Checkbox defaultChecked />
                <Input
                  className="bind"
                  value={staff.name}
                  labelPosition="right"
                  action={{
                    icon: 'search',
                    type: 'button',
                    onClick: (e) => this.staffSearchClick()
                  }}
                  onClick={(e) => this.staffSearchClick()}
                  label={{
                    basic: true,
                    content: 'x',
                    onClick: (e) => this.deleteSelectedStaff(),
                    onMouseOver: (e) => this.style(e, 'over'),
                    onMouseOut: (e) => this.style(e, 'out')
                  }}
                  placeholder="사용자 전체"
                />
              </Form.Group>
              {/* 안내 텍스트 - 김앤장 급여공제에서만 표시 */}
              {this.props.isKimAndChang && (
                <div
                  style={{
                    marginTop: '8px',
                    fontSize: '12px',
                    color: '#666',
                    fontStyle: 'italic'
                  }}
                >
                  ※ 2025년 7월 1일 부로 사무소지원금이 76.7%로 변경 되었습니다.
                </div>
              )}
              {this.props.isWelcomeSystemINC ? (
                <div
                  style={{
                    marginTop: '8px',
                    fontSize: '12px',
                    color: '#666',
                    fontStyle: 'italic'
                  }}
                >
                  ※ 2026년 1월 1일 부로 공제율이 45%로 변경 되었습니다.
                </div>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

DeductionSearchBox.propTypes = propTypes;
DeductionSearchBox.defaultProps = defaultProps;

export default DeductionSearchBox;
